import { TrackingEmailsAndPageAnalyticsAggregatesSchema } from "@redotech/redo-model/analytics/analytics";
import * as z from "zod";

export const getTrackingEmailsAndPageAnalyticsAggregates = {
  name: "getTrackingEmailsAndPageAnalyticsAggregates" as const,
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    upsellDays: z.number().positive().optional(),
  }),
  output: TrackingEmailsAndPageAnalyticsAggregatesSchema,
};
